// extracted by mini-css-extract-plugin
module.exports = {"container":"ImageLinks_container__V1H6f","heading":"ImageLinks_heading__4i4a4"};